import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DataLayerEffects } from './effects/data-layer.effects';
import { TrackingEffects } from './effects/tracking.effects';
import { reducers } from './reducers';
import { DataLayerService } from './services/data-layer.service';
import { TrackingService } from './services/tracking.service';

@NgModule({
  imports: [
    StoreModule.forFeature('analytics', reducers),
    EffectsModule.forFeature([TrackingEffects, DataLayerEffects])
  ],
  providers: [DataLayerService, TrackingService]
})
export class AnalyticsModule {}
